import { InputCount, InputCountProps } from './InputCount';
import { TranslateButton } from './TranslateButton';
import { SendButton } from './SendButton';
import { useMessageEditorTranslateButtonChange } from '../hooks/useMessageEditorTranslate';

interface MessageEditorFooterProps {
  conversation: Conversation.Conversation;
  claimId?: string;
  targetLang: General.Language;
  translating: boolean;
  trimInput: string;
  sendBtnDisable: boolean;
  onTranslateClick: () => void;
  doSend: () => void;
  onInputOverflowChange: InputCountProps['onInputOverflowChange'];
}

export const MessageEditorFooter = (props: MessageEditorFooterProps) => {
  const {
    conversation,
    claimId,
    targetLang,
    translating,
    trimInput,
    sendBtnDisable,
    onTranslateClick,
    doSend,
    onInputOverflowChange,
  } = props;
  const { conversationId, region, channel, controlStatus } = conversation;

  const { onChange } = useMessageEditorTranslateButtonChange(conversationId, region);

  return (
    <div className="flex p-2 items-center justify-between">
      <InputCount
        conversation={conversation}
        claimId={claimId}
        onInputOverflowChange={onInputOverflowChange}
      />
      <div className="flex items-center gap-2">
        <TranslateButton
          region={region}
          channel={channel}
          controlStatus={controlStatus}
          targetLang={targetLang}
          onChange={onChange}
          translating={translating}
          trimInput={trimInput}
          onTranslateClick={onTranslateClick}
        />
        <SendButton translating={translating} sendBtnDisable={sendBtnDisable} doSend={doSend} />
      </div>
    </div>
  );
};
